"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DateParser_1 = require("../../core/model/data-dictionary/parsers/DateParser");

var StructPropBuilder_1 = require("../../core/model/data-dictionary/StructPropBuilder");

var DomainObject_1 = require("../../core/model/DomainObject");
/**
 * Currency rates of {@link Currency}
 *
 * @author RV
 * @author JMe
 */


var CurrencyRate =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(CurrencyRate, _DomainObject_1$Domai);

  /**
   * Construct currency rate
   *
   * @param validFrom
   * @param validTo
   * @param rate currency rate
   */
  function CurrencyRate(validFrom, validTo, rate) {
    var _this;

    _classCallCheck(this, CurrencyRate);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(CurrencyRate).call(this));
    _this.validFrom = validFrom;
    _this.validTo = validTo;
    _this.rate = rate;
    return _this;
  }

  return CurrencyRate;
}(DomainObject_1.DomainObject);

exports.CurrencyRate = CurrencyRate; // tslint:disable-next-line:member-ordering

CurrencyRate.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(CurrencyRate.name);
  return {
    validFrom: builder.date('validFrom', DateParser_1.DateParser.ISO_PATTERN),
    validTo: builder.date('validTo', DateParser_1.DateParser.ISO_PATTERN),
    rate: builder.bigNum('rate')
  };
}();